import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Tooltip from "./Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "./ValidationMessage";

const CheckBoxWithChild = (props) => {
	const hasError = !!props.error;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const sizeClassName = props.size ? `l-grid__col:${props.size}/12` : "l-grid__col:12/12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.error ? <ValidationMessage message={props.error} /> : null;
	const optionList = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];
	const horizontal = !!props.horizontal;
	const tooltip = props.tooltip ? props.tooltip : "";
	const disabled = !!props.disabled;
	const locked = !!props.locked;
	const optional = !!props.optional;
	const style = props.style ? props.style : { marginBottom: "0px" };

	let value = "null";
	if (props.value != null) {
		if (props.value == false || props.value == "false") {
			value = false;
		} else if (props.value == true || props.value == "true") {
			value = true;
		}
	}

	const child = props.child && (props.value === "true" || props.value == true) ?
		props.child : null;

	return (

		<div className={""}>
			<div key={props.name} className="c-checkbox " style={style}>
				<label className="c-checkbox__container">
					<input
						className="c-checkbox__input"
						type="checkbox"
						name={props.name}
						onChange={props.onChange}
						value={props.value}
						checked={value}
						id={props.name}
						disabled={disabled} />
					<span className="c-checkbox__holder">
						<span
							className="c-icon c-code__icon c-checkbox__icon"
							aria-hidden="true"
							focusable="false"
						>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M8.28455 15L3 10.9487L4.32114 9.25641L7.86179 12.0256L14.2033 5L16 6.28205L8.28455 15Z"
								/>
							</svg>
						</span>
					</span>
					<p className="c-checkbox__label">{props.label}</p>
				</label>
			</div>
			{child}
			{validation}
		</div>
	);
};

CheckBoxWithChild.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	onChange: PropTypes.func.isRequired,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	horizontal: PropTypes.bool,
	labelInside: PropTypes.bool,
	size: PropTypes.number,
	error: PropTypes.string,
	disabled: PropTypes.bool,
	locked: PropTypes.bool,
	lockedText: PropTypes.string,
	optional: PropTypes.bool,
	child: PropTypes.element,
	style: PropTypes.object
};

export default CheckBoxWithChild;
